<template>
  <div class="layout flex flex-col">
    <div
      v-if="
        (userPlanDetail && userPlanDetail.recurringPaymentStatus !== 1) ||
        userPlanDetail.isCompleted
      "
      class="trial-bar bg-rdc-blue w-full flex items-center justify-center gap-3 h-fit py-3 flex-wrap pl-[110px] lg:pl-[246px]"
    >
      <p class="text-sm text-primary-white text-center">
        {{ bannerText }}
      </p>
      <a
        v-if="
          (userPlanDetail.recurringPaymentStatus !== 0 &&
            userPlanDetail.isTrial) ||
          userPlanDetail.isCompleted
        "
        :href="getNavigateLink"
      >
        <div
          class="default see-plans h-4 text-primary-base text-xs font-medium"
          small
        >
          {{ $t("banner.warning_message.see_plans") }}
        </div>
      </a>
      <a
        v-if="
          userPlanDetail.isTransactionRequired !== null &&
          userPlanDetail.isTransactionRequired
        "
        :href="getNavigateCardUpdateLink"
      >
        <div
          class="default see-plans h-4 text-primary-base text-xs font-medium"
          small
        >
          {{ $t("banner.warning_message.card_update") }}
        </div>
      </a>
    </div>
    <div>
      <div
        :class="{ 'profile-layout': isProfilePage }"
        class="sidebar_menu fixed z-10 top-0 bottom-0 left-0"
      >
        <router-link
          :to="{ path: '/devices' }"
          class="sidebar_menu-logo pl-9 pt-8 flex items-center cursor-pointer"
        >
          <img
            class="sidebar-logo-main w-[128px]"
            :class="{ 'profile-layout-logo-main': isProfilePage }"
            src="@/assets/images/logo-main.svg"
            alt="logo"
          />
          <img
            class="sidebar-logo-main-2 w-[28px]"
            :class="{ 'profile-layout-logo-main-2': isProfilePage }"
            src="@/assets/images/logo-main-2.svg"
            alt="logo"
          />
        </router-link>
        <ul class="sidebar_menu__list flex flex-col gap-2">
          <li>
            <router-link
              :to="{ path: '/devices' }"
              class="sidebar_menu__list__item"
              :class="{
                active: activeLink === '/devices' || activeLink === '/',
              }"
            >
              <svg
                class="logo-devices"
                width="20"
                height="20"
                viewBox="0 0 18 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.861817 16.2178L0.861818 6.21777C0.861818 2.21777 1.86182 1.21777 5.86182 1.21777L11.8618 1.21777C15.8618 1.21777 16.8618 2.21777 16.8618 6.21777L16.8618 16.2178C16.8618 20.2178 15.8618 21.2178 11.8618 21.2178L5.86182 21.2178C1.86182 21.2178 0.861816 20.2178 0.861817 16.2178Z"
                  stroke="#848FAC"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.86182 17.7178L10.8618 17.7178"
                  stroke="#848FAC"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div
                :class="{ 'profile-layout-text': isProfilePage }"
                class="text"
              >
                {{ $t("navigation.main.devicelist") }}
              </div>
            </router-link>
          </li>
          <li data-v-step="App">
            <router-link
              :to="{ path: '/applications' }"
              class="sidebar_menu__list__item"
              :class="{ active: activeLink === '/applications' }"
            >
              <svg
                class="logo-apps"
                width="20"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.03365 3.32312H8.03363V3.33V5.23C8.03363 6.0684 7.81535 6.46196 7.62547 6.65184C7.43559 6.84172 7.04203 7.06 6.20363 7.06H4.30363C3.46523 7.06 3.07167 6.84172 2.88179 6.65184C2.69191 6.46196 2.47363 6.0684 2.47363 5.23V3.33C2.47363 2.49161 2.69187 2.09891 2.88186 1.90934C3.0724 1.71923 3.46848 1.5 4.31363 1.5H6.21363C7.05257 1.5 7.44501 1.71853 7.63304 1.90697C7.82046 2.09482 8.03749 2.486 8.03365 3.32312ZM6.21363 0H4.31363C2.12363 0 0.973633 1.15 0.973633 3.33V5.23C0.973633 7.41 2.12363 8.56 4.30363 8.56H6.20363C8.38363 8.56 9.53363 7.41 9.53363 5.23V3.33C9.54363 1.15 8.39363 0 6.21363 0ZM15.7436 1.5H17.6436C18.482 1.5 18.8755 1.71828 19.0654 1.90816C19.2553 2.09804 19.4736 2.4916 19.4736 3.33V5.23C19.4736 6.0684 19.2553 6.46196 19.0654 6.65184C18.8755 6.84172 18.482 7.06 17.6436 7.06H15.7436C14.9052 7.06 14.5116 6.84172 14.3217 6.65184C14.1319 6.46196 13.9136 6.0684 13.9136 5.23V3.33C13.9136 2.4916 14.1319 2.09804 14.3217 1.90816C14.5116 1.71828 14.9052 1.5 15.7436 1.5ZM17.6436 0H15.7436C13.5636 0 12.4136 1.15 12.4136 3.33V5.23C12.4136 7.41 13.5636 8.56 15.7436 8.56H17.6436C19.8236 8.56 20.9736 7.41 20.9736 5.23V3.33C20.9736 1.15 19.8236 0 17.6436 0ZM17.6436 12.9299H15.7436C14.9052 12.9299 14.5116 13.1482 14.3217 13.3381C14.1319 13.528 13.9136 13.9215 13.9136 14.7599V16.6599C13.9136 17.4983 14.1319 17.8919 14.3217 18.0818C14.5116 18.2717 14.9052 18.4899 15.7436 18.4899H17.6436C18.482 18.4899 18.8755 18.2717 19.0654 18.0818C19.2553 17.8919 19.4736 17.4983 19.4736 16.6599V14.7599C19.4736 13.9215 19.2553 13.528 19.0654 13.3381C18.8755 13.1482 18.482 12.9299 17.6436 12.9299ZM15.7436 11.4299H17.6436C19.8236 11.4299 20.9736 12.5799 20.9736 14.7599V16.6599C20.9736 18.8399 19.8236 19.9899 17.6436 19.9899H15.7436C13.5636 19.9899 12.4136 18.8399 12.4136 16.6599V14.7599C12.4136 12.5799 13.5636 11.4299 15.7436 11.4299ZM8.03365 14.7631H8.03363V14.7699V16.6699C8.03363 17.5083 7.81535 17.9019 7.62547 18.0918C7.43559 18.2817 7.04203 18.4999 6.20363 18.4999H4.30363C3.46525 18.4999 3.07254 18.2817 2.88297 18.0917C2.69286 17.9012 2.47363 17.5051 2.47363 16.6599V14.7599C2.47363 13.9215 2.69187 13.5288 2.88186 13.3393C3.0724 13.1492 3.46848 12.9299 4.31363 12.9299H6.21363C7.05256 12.9299 7.44414 13.1484 7.63186 13.337C7.81953 13.5255 8.0375 13.9192 8.03365 14.7631ZM6.21363 11.4299H4.31363C2.12363 11.4299 0.973633 12.5799 0.973633 14.7599V16.6599C0.973633 18.8499 2.12363 19.9999 4.30363 19.9999H6.20363C8.38363 19.9999 9.53363 18.8499 9.53363 16.6699V14.7699C9.54363 12.5799 8.39363 11.4299 6.21363 11.4299Z"
                  fill="#848FAC"
                />
              </svg>
              <div
                :class="{ 'profile-layout-text': isProfilePage }"
                class="text"
              >
                {{ $t("navigation.main.apps") }}
              </div>
            </router-link>
          </li>
          <li>
            <div
              v-if="userPlanDetail && userPlanDetail.isBuyable"
              class="buy-button-container p-4 mt-5 absolute bottom-0 w-full"
            >
              <a
                :class="buyingPlanButtonStyle"
                :href="userPlanDetail.isBuyable ? getNavigateLink : '#'"
              >
                Buy Pro Version
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div
        :class="{ 'profile-layout-article': isProfilePage }"
        class="layout-article"
      >
        <Header />
        <img
          v-if="activeLink === '/pricing' && getTheme === 'dark'"
          class="gradient"
          src="@/assets/images/dark-gradient.png"
          alt="gradient"
        />
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const trialUserTimeBySecond = 2 * 60;
const firstControlTimeBySecond = 15 * 60;
const secondControlTimeBySecond = 30 * 60;
const lastControlTimeBySecond = 45 * 60;
import Header from "@/components/Header";

const navigateBaseUrl = process.env.VUE_APP_PAYMENT_LINK;
export default {
  data() {
    return {
      modalIsOpen: false,
      isProfilePage: false,
      time: 0,
      interval: null,
      isPricingPage: false,
      theme: false,
      currentPage: "",
      userPlanDetail: "",
      isConfirmationPopup: false,
    };
  },
  components: {
    Header,
  },
  beforeMount() {
    this.$store.dispatch("initTheme");
  },
  computed: {
    ...mapGetters([
      "connectionStatus",
      "joinedUser",
      "isTrialUser",
      "getTheme",
    ]),
    activeLink() {
      return this.$route.path;
    },
    getNavigateLink() {
      const token = localStorage.getItem("access_token");
      return `${navigateBaseUrl}/?token=${token}`;
    },
    getNavigateCardUpdateLink() {
      const token = localStorage.getItem("access_token");
      return `${navigateBaseUrl}/cardUpdate?&token=${token}`;
    },
    buyingPlanButtonStyle() {
      return this.userPlanDetail.isBuyable
        ? "default"
        : "default bg-rdc-dark-gray";
    },
    bannerText() {
      const trialExpireDays = this.getDateDiff(
        this.userPlanDetail.trialExpireDate
      );
      const recurringExpireDays = this.getDateDiff(
        this.userPlanDetail.recurringPaymentExpireDate
      );

      if (
        this.userPlanDetail.recurringPaymentStatus === null &&
        trialExpireDays < 0
      ) {
        return this.$t("banner.warning_message.trial_end");
      }
      if (this.userPlanDetail.isCompleted) {
        return this.$t("banner.warning_message.subscription_has_ended");
      }

      if (
        this.userPlanDetail.isTransactionRequired !== null &&
        this.userPlanDetail.isTransactionRequired
      ) {
        return this.$t("banner.warning_message.failure_receive_payment");
      }

      if (
        this.userPlanDetail.recurringPaymentStatus === 1 &&
        recurringExpireDays < 0
      ) {
        return this.$t("banner.warning_message.non_payment");
      }

      if (
        this.userPlanDetail.recurringPaymentStatus === 2 &&
        !this.userPlanDetail.isTrial
      ) {
        return this.$t("banner.warning_message.cancel_subscription");
      }
      if (
        (this.userPlanDetail.recurringPaymentStatus === null &&
          trialExpireDays > 0) ||
        (this.userPlanDetail.isTrial && trialExpireDays > 0)
      ) {
        return `${this.$t(
          "banner.warning_message.trail.part_one"
        )} ${trialExpireDays} ${this.$t(
          "banner.warning_message.trail.part_two"
        )}`;
      }

      return this.$t("banner.warning_message.subscription_has_ended");
    },
  },
  methods: {
    ...mapActions(["destroySession", "emitNotification"]),
    startTimer() {
      this.interval = setInterval(() => {
        this.time++;
      }, 1000);
    },
    destroy() {
      this.$socket.emit("session_end");
    },
    secondsToTime(e) {
      const m = Math.floor((e % 3600) / 60)
          .toString()
          .padStart(2, "0"),
        s = Math.floor(e % 60)
          .toString()
          .padStart(2, "0");

      return m + ":" + s;
    },
    trialControl(time) {
      if (time === trialUserTimeBySecond) {
        clearInterval(this.interval);
        this.$confirm({
          message: `Your time has expired because you are a limited user.`,
          button: {
            yes: "End Session",
          },
          callback: (confirm) => {
            if (confirm) {
              this.destroy();
            }
          },
        });
        setTimeout(() => {
          this.destroy();
        }, 2500);
      }
    },
    firstControl(time) {
      if (time === firstControlTimeBySecond) {
        clearInterval(this.interval);
        this.$confirm({
          message: `You’ve spent 15 minutes. Would you like to go on? Please click “Continue” to keep working. `,
          button: {
            no: "End Session",
            yes: "Continue",
          },
          callback: (confirm) => {
            if (confirm) {
              this.startTimer();
            } else {
              this.destroy();
            }
          },
        });
      }
    },
    secondControl(time) {
      if (time === secondControlTimeBySecond) {
        clearInterval(this.interval);
        this.$confirm({
          message: `You’ve spent 30 minutes. Would you like to go on? Please click “Continue” to keep working.`,
          button: {
            no: "End Session",
            yes: "Continue",
          },
          callback: (confirm) => {
            if (confirm) {
              this.startTimer();
            } else {
              this.destroy();
            }
          },
        });
      }
    },
    lastControl(time) {
      if (time === lastControlTimeBySecond) {
        clearInterval(this.interval);
        this.$confirm({
          message: `You’ve spent the maximum testing minutes you’ve on your current session. Choose the same or a new device to keep working.`,
          button: {
            yes: "End Session",
          },
          callback: (confirm) => {
            if (confirm) {
              this.destroy();
            }
          },
        });
        setTimeout(() => {
          this.destroy();
        }, 10000);
      }
    },
    // get date difference between two dates return days
    getDateDiff(endDate) {
      if (endDate) {
        const start = new Date(this.userPlanDetail.serverTime);
        const end = new Date(endDate);
        const diff = end.getTime() - start.getTime();
        const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
        return days;
      }
    },

    endSession() {
      this.$confirm({
        message: `Are you sure want to end your current session?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            this.destroy();
          }
        },
      });
    },
  },
  watch: {
    "$route.name"(newValue) {
      this.isProfilePage =
        newValue === "MyProfile" ||
        newValue === "ChangePassword" ||
        newValue === "Preferences";
    },
    connectionStatus: {
      handler(val) {
        if (val === 1) {
          this.startTimer();
        }
      },
    },
    time: {
      handler(val) {
        if (this.isTrialUser) {
          this.trialControl(val);
        }
        this.firstControl(val);
        this.secondControl(val);
        this.lastControl(val);
      },
    },
    joinedUser: {
      handler(value) {
        if (value) {
          this.userPlanDetail = value.client;
        }
      },
      immediate: true,
    },
  },
  created() {
    this.isProfilePage =
      this.$route.name === "MyProfile" ||
      this.$route.name === "ChangePassword" ||
      this.$route.name === "Preferences";
  },
};
</script>
<style>
.gradient {
  background-size: cover;
  height: 100%;
  width: 100%;
  left: 0;
  z-index: -1;
  position: absolute;
}
.sidebar_menu {
  @apply min-w-[246px]
  flex
  flex-col
  gap-14
  border-r border-gray-border dark:border-greyscale-800
  bg-primary-white dark:bg-dark-mode-150;
}
.sidebar_menu .sidebar_menu__list .sidebar_menu__list__item {
  @apply flex
    items-center
    justify-start
    gap-4
    cursor-pointer
    rounded-r-2xl
    h-12
    pl-11;
}
.sidebar_menu .sidebar_menu__list .sidebar_menu__list__item .text {
  @apply text-sm text-greyscale-575;
}
.sidebar_menu .sidebar_menu__list .active {
  @apply bg-primary-400 bg-opacity-10 max-w-[186px];
}
.sidebar_menu .sidebar_menu__list .active .logo-devices path {
  @apply stroke-current text-primary-base;
}
.sidebar_menu .sidebar_menu__list .active .logo-apps path {
  @apply fill-current text-primary-base;
}
.sidebar_menu .sidebar_menu__list .active .text {
  @apply font-bold
    text-primary-base;
}
.layout-article {
  @apply ml-[246px];
}
@media (max-width: 1024px) {
  .sidebar_menu .sidebar_menu-logo .sidebar-logo-main {
    @apply hidden;
  }
  .sidebar_menu .sidebar_menu-logo .sidebar-logo-main-2 {
    @apply block;
  }
  .sidebar_menu .sidebar_menu__list .sidebar_menu__list__item .text {
    @apply hidden;
  }
  .sidebar_menu {
    @apply min-w-[110px];
  }
  .sidebar_menu .sidebar_menu__list .router-link-active {
    @apply bg-primary-400 bg-opacity-10 max-w-[86px];
  }
  .layout-article {
    @apply ml-[110px];
  }
}
@media (min-width: 1025px) {
  .sidebar_menu .sidebar_menu-logo .sidebar-logo-main {
    @apply block;
  }
  .sidebar_menu .sidebar_menu-logo .sidebar-logo-main-2 {
    @apply hidden;
  }
  .sidebar_menu .sidebar_menu__list .sidebar_menu__list__item .text {
    @apply block;
  }
}
.profile-layout-logo-main {
  @apply !hidden;
}
.profile-layout-logo-main-2 {
  @apply !block;
}
.profile-layout-text {
  @apply !hidden;
}
.profile-layout {
  @apply !min-w-[110px];
}
.profile-layout-article {
  @apply !ml-[110px];
}
</style>
